export default "__VITE_ASSET__cf3e777f__"